import { render, staticRenderFns } from "./JirutoCommunity.vue?vue&type=template&id=1c8057eb&scoped=true&"
import script from "./JirutoCommunity.vue?vue&type=script&lang=js&"
export * from "./JirutoCommunity.vue?vue&type=script&lang=js&"
import style0 from "./JirutoCommunity.vue?vue&type=style&index=0&id=1c8057eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8057eb",
  null
  
)

export default component.exports